module.exports = __webpack_public_path__ + "img/arg_logo.5784aca8.png";